export default __webpack_public_path__ + "static/media/popup_coffee.6db36ec2.png";